var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-more-spots"},[_c('svg',{staticClass:"icon-star"},[_c('use',{attrs:{"xlink:href":"#icon-star"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }